import React, { FC, useCallback } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Grid from '@mui/material/Grid';
import Thumb from 'components/MediaEditorThumb';
import PreviewThumb from 'components/MediaEditorPreviewThumb';

import { GalleryItem } from 'components/MediaEditor';

import { MediaEditorPreviews_media$key } from '__generated__/MediaEditorPreviews_media.graphql';

type PreviewsProps = {
  media: MediaEditorPreviews_media$key | null;
  preview: GalleryItem[];
  selected: string[];
  disabled?: boolean;
  onSelect: (selected: string[]) => void;
  onDelete: (id: string) => void;
};

const MediaEditorPreviews: FC<PreviewsProps> = props => {
  const { preview, selected, disabled, onSelect, onDelete } = props;

  const media = useFragment(
    graphql`
      fragment MediaEditorPreviews_media on MediaConnection {
        edges {
          node {
            id
            ...MediaEditorThumb_media
          }
        }
      }
    `,
    props.media
  );

  const handleSelect = useCallback(
    (id: string) => {
      const current = selected.find(item => item === id);

      if (current) {
        onSelect(selected.filter(item => item !== id));
      } else {
        onSelect([...selected, id]);
      }
    },
    [onSelect, selected]
  );

  return (
    <Grid container spacing={1}>
      {media?.edges.map(({ node }) => (
        <Thumb
          selected={Boolean(selected.find(item => item === node.id))}
          disabled={disabled}
          key={node.id}
          media={node}
          onDelete={onDelete}
          onSelect={handleSelect}
        />
      ))}

      {preview.map((file, i) => (
        <PreviewThumb key={i} file={file} />
      ))}
    </Grid>
  );
};

export default MediaEditorPreviews;
